export default {"src":"/_next/static/media/thumb_img2.01fe594c.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};